// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"CustomizeProductBrandRefresh_pageWrapper__Biv1d"};